module.exports = __webpack_public_path__ + "static/media/step3.15bec4b5.svg";